(() => {
  'use strict';
  const money = cents => new Intl.NumberFormat('en-AU', {
    style: 'currency', currency: (window.SurfButta && window.SurfButta.currency) || 'AUD'
  }).format((Number(cents) || 0) / 100).replace(/\.00$/, '');

  // Quantity − / + buttons around a number input.
  document.addEventListener('click', event => {
    const step = event.target.closest('[data-sb-qty-step]');
    if (!step) return;
    const input = step.closest('[data-sb-qty]')?.querySelector('input');
    if (!input) return;
    const min = Number(input.min) || 1;
    const max = Number(input.max) || 99;
    input.value = Math.min(max, Math.max(min, (Number(input.value) || min) + Number(step.dataset.sbQtyStep)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Ad landing hero: picking a product updates the photo, price, stock,
  // delivery line and the item that "Add to bag" sends.
  document.querySelectorAll('[data-sb-lp]').forEach(hero => {
    let data = [];
    try { data = JSON.parse(hero.querySelector('[data-sb-lp-data]').textContent); } catch (_) { return; }
    if (!data.length) return;
    const q = selector => hero.querySelector(selector);
    const inputs = [...hero.querySelectorAll('.sb-lp-pick__input')];
    const form = q('.sb-lp-hero__form');
    const variant = q('[data-sb-lp-variant]');
    const preorder = q('[data-sb-lp-preorder]');
    const add = q('[data-sb-lp-add]');
    const addLabel = q('[data-sb-lp-add-label]');
    const addPrice = q('[data-sb-lp-add-price]');
    const choose = q('[data-sb-lp-choose]');
    const img = q('.sb-lp-hero__pack');
    const nameNode = q('[data-sb-lp-name]');
    const word = q('[data-sb-lp-word]');
    const price = q('[data-sb-lp-price]');
    const compare = q('[data-sb-lp-compare]');
    const status = q('[data-sb-lp-status]');
    const facts = q('[data-sb-lp-facts]');
    const ship = q('[data-sb-lp-ship]');
    const d = hero.dataset;
    const label = d.label || 'Add to bag';
    const shipText = cents => {
      if (cents >= Number(d.free)) return 'Free standard delivery';
      const small = cents < Number(d.smallUnder);
      return `${money(small ? d.small : d.standard)} delivery${small ? ' for 1–2 bars' : ''} · free from ${money(d.free)}`;
    };
    let current = Math.max(0, inputs.findIndex(input => input.checked));

    const show = (index, remember) => {
      const item = data[index];
      if (!item) return;
      current = index;
      if (inputs[index]) inputs[index].checked = true;
      hero.style.setProperty('--flood', item.colour);
      hero.classList.toggle('is-light', !!item.light);
      if (nameNode) nameNode.textContent = item.name;
      if (word) word.textContent = item.name;
      if (img && item.img) {
        img.srcset = item.srcset;
        img.src = item.img;
        img.alt = item.alt;
      }
      if (price) price.textContent = money(item.price);
      if (compare) {
        compare.hidden = !(item.compare > item.price);
        compare.textContent = money(item.compare);
      }
      if (status) status.textContent = item.available ? (item.preorder ? `Preorder · ${d.preorderText}` : 'In stock') : 'Sold out';
      if (facts) facts.textContent = item.facts || '';
      if (ship) ship.textContent = shipText(item.price);
      if (variant) variant.value = item.variant;
      if (preorder) preorder.disabled = !item.preorder;
      if (add) {
        add.hidden = item.multi;
        add.disabled = !item.available;
      }
      if (addLabel) addLabel.textContent = item.available ? label : 'Sold out';
      if (addPrice) addPrice.textContent = money(item.price);
      if (choose) {
        choose.hidden = !item.multi;
        choose.href = item.url;
      }
      const error = form && form.querySelector('[data-form-error]');
      if (error) error.hidden = true;
      if (remember) {
        // Keeps any ad tracking parameters already in the address.
        const url = new URL(window.location.href);
        url.searchParams.set('colour', item.keys.split(',')[0]);
        window.history.replaceState(window.history.state, '', url);
      }
      document.dispatchEvent(new CustomEvent('sb:lp-select', { detail: { hero, item } }));
    };

    inputs.forEach(input => input.addEventListener('change', () => show(Number(input.value), true)));

    // Ads can open the page on the product they showed: ?colour=pink, ?colour=full-range-box
    const params = new URL(window.location.href).searchParams;
    const wanted = (params.get('colour') || params.get('product') || '').toLowerCase().trim();
    if (wanted) {
      const match = data.findIndex(item => item.keys.split(',').includes(wanted));
      if (match >= 0) current = match;
    }
    show(current, false);
    // Bring the chosen product into view in the swipeable picker without moving the page.
    const track = q('.sb-lp-pick__track');
    const chosen = inputs[current] && inputs[current].nextElementSibling;
    if (track && chosen) {
      const t = track.getBoundingClientRect();
      const c = chosen.getBoundingClientRect();
      if (c.left < t.left + 16 || c.right > t.right - 16) track.scrollLeft += c.left - t.left - (t.width - c.width) / 2;
    }

    // "Ready to make it yours?" further down repeats the same choice.
    const repeat = document.querySelector('[data-sb-lp-repeat]');
    if (repeat && form && add) {
      const fallback = document.querySelector('[data-sb-lp-repeat-fallback]');
      const alt = document.querySelector('[data-sb-lp-repeat-alt]');
      const sync = () => {
        const item = data[current];
        const canAdd = !!item && !item.multi && item.available;
        repeat.hidden = !canAdd;
        if (fallback) fallback.hidden = canAdd;
        if (alt) alt.hidden = !canAdd;
        if (!item) return;
        repeat.querySelector('[data-sb-lp-repeat-label]').textContent = `Add ${item.name} to bag`;
        repeat.querySelector('[data-sb-lp-repeat-price]').textContent = money(item.price);
      };
      document.addEventListener('sb:lp-select', sync);
      sync();
      repeat.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(add); else add.click();
      });
    }
  });

  // Phones: the homepage colours change only when the shopper taps one. Tapping the
  // current colour is the hero's own way of stopping the automatic cycling.
  if (window.matchMedia('(max-width: 989px)').matches) {
    document.querySelectorAll('[data-sb-flood][data-autoplay="true"]').forEach(hero => {
      const active = hero.querySelector('.sb-flood__dot[aria-pressed="true"]');
      if (active) active.click();
    });
  }

  // Product gallery: photos after the first load on the first swipe or thumbnail tap.
  document.querySelectorAll('[data-sb-gallery]').forEach(gallery => {
    const deferred = [...gallery.querySelectorAll('img[data-src]')];
    if (!deferred.length) return;
    const wake = () => deferred.forEach(img => {
      if (!img.dataset.src) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.src;
      delete img.dataset.srcset;
    });
    const track = gallery.querySelector('[data-sb-gallery-track]');
    ['pointerdown', 'focusin'].forEach(type => gallery.addEventListener(type, wake, { once: true, passive: true }));
    if (track) track.addEventListener('scroll', wake, { once: true, passive: true });
    if (window.matchMedia('(min-width: 821px)').matches) window.addEventListener('load', () => setTimeout(wake, 1500), { once: true });
  });

  // Collection quick filters.
  document.querySelectorAll('[data-sb-filters]').forEach(bar => {
    const grid = document.querySelector(bar.dataset.sbFilters);
    if (!grid) return;
    const cards = [...grid.querySelectorAll('[data-sb-type]')];
    const buttons = [...bar.querySelectorAll('[data-sb-filter]')];
    const status = bar.querySelector('[data-sb-filter-status]');
    const apply = type => {
      let shown = 0;
      cards.forEach(card => {
        const match = type === 'all' || card.dataset.sbType === type;
        card.hidden = !match;
        if (match) shown += 1;
      });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sbFilter === type)));
      if (status) status.textContent = `${shown} ${shown === 1 ? 'product' : 'products'}`;
    };
    buttons.forEach(button => button.addEventListener('click', () => apply(button.dataset.sbFilter)));
    bar.hidden = false;
  });
})();